import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';



const API_URL = 'https://localhost:7102/api/Bank';


const BankEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();


    const [formData, setFormData] = useState({

        BankName: '',
        CompanyId: '',
        AccountType: '',
        IFSC: '',
        AccountNo: '',
        Branch: '',
        OpeningBalance: '',
        UPINo: '',
        IsPrimaryUPI: false,
        ModifiedBy: userId,
        AccType: '',
    });


    //payment
    const [selectedPaymentType, setSelectedPaymentType] = useState("true");
    const handleChangepay = (event) => {
        setSelectedPaymentType(event.target.value);

    };
    const [selectedPaymentmethod, setSelectedPaymentmethod] = useState("");
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('AccountTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(accType => ({
                    value: accType.Id,
                    label: accType.Name
                }));
                setPaymentmethodOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            AccTypeId: selectedOption ? selectedOption.value : null,
        }));
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('Bank', `/Bank/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    console.log(response);
                    const selectedOption = paymentmethodOptions.find(option => option.value === response.response_data.AccountType);
                    setSelectedPaymentmethodType(selectedOption);
                }
            })
            .catch((error) => {
                console.error('Error fetching Location Details:', error);
            });
    }, [id]);

    const handleChange = event => {
        const { name, value } = event.target;

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleChangecheckbox = event => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value === 'true'; // Ensure the value is boolean
        setFormData(prevData => ({
            ...prevData,
            [name]: newValue
        }));
    };



    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));


        updateData('Bank', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/BankIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>

                <div className='w-full mb-2 flex items-center'>
                    <h4 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>Bank Edit</h4>
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                        onClick={handleSubmit}
                    >
                        Update
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/BankIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px' }}
                    >
                        Cancel
                    </Button>


                </div>
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}
                <div className="w-full mb-4 flex">
                    <div className="w-1/2 mr-2">

                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="BankName">
                            Bank Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="BankName"
                            value={formData.BankName}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Bank Name"
                            maxLength={50}
                        />
                    </div>
                    <div className="w-1/2 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AccountNo">
                            Account No
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="AccountNo"
                            value={formData.AccountNo}
                            // onChange={handleChange}
                            onChange={(e) => {
                                const input = e.target.value.replace(/\D/g, ''); // Allow only digits
                                if (input.length <= 25) { // Limit to maxLength
                                    setFormData(prevData => ({
                                        ...prevData,
                                        AccountNo: input
                                    }));
                                }
                            }}
                            type="text"
                            placeholder="Enter Account No"
                            maxLength={25}
                        />
                    </div>
                    <div className="w-1/4 mr-2">

                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="IFSC">
                            IFSC Code
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="IFSC"
                            value={formData.IFSC}
                            onChange={handleChange}
                            maxLength={20}
                            type="text"
                            placeholder="Enter IFSC Code"
                        />
                    </div>
                    <div className="w-1/3 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Branch">
                            Branch
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="Branch"
                            value={formData.Branch}
                            onChange={handleChange}
                            maxLength={20}
                            type="text"
                            placeholder="Enter Branch"
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="OpeningBalance">
                            Opening Balance
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="OpeningBalance"
                            value={formData.OpeningBalance}
                            
                            onChange={(e) => {
                                const input = e.target.value;
                                let filteredInput = input.replace(/[^0-9.]/g, ''); 
                                if (filteredInput.indexOf('.') !== filteredInput.lastIndexOf('.')) {
                                    filteredInput = filteredInput.slice(0, filteredInput.lastIndexOf('.'));
                                }
                                if (/^\d+(\.\d{0,2})?$/.test(filteredInput) || filteredInput === '') {
                                    setFormData(prevData => ({
                                        ...prevData,
                                        OpeningBalance: filteredInput
                                    }));
                                }
                            }}
                            type="text"
                            placeholder="Opening Balance"
                            maxLength={10}

                        />
                    </div>

                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-1/3 mr-2">
                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                            AccountType
                        </label>

                        <Select
                            //name="AccountType"
                            value={selectedPaymentmethodType || (formData.AccType ? { value: formData.AccType, label: formData.AccType } : '')}

                            //  value={selectedPaymentmethodType}
                            onChange={handlePaymentTypeChange}
                            options={paymentmethodOptions}
                            placeholder="Account Type"
                            isSearchable
                        />
                    </div>
                    <div className="w-1/3 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="UPINo">
                            UPI ID
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="UPINo"
                            value={formData.UPINo}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Your UPI ID"
                            maxLength={20}
                        />
                    </div>


                    {/* <div className="w-1/2 radio-group" style={{ marginLeft: '10px' }}>
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="upidno">
                            Primary UPI ID
                        </label>
                        <div className="flex items-center">
                            <label className="block uppercase tracking-wide  font-bold mr-2" style={{ color: 'darkgreen' }}>
                                <input type="radio"
                                    name="PaymentType"
                                    value="true"
                                    checked={selectedPaymentType === "true"}
                                    onChange={handleChange} />

                            </label>

                        </div>
                    </div> */}

                    <div className="w-1/2 radio-group" style={{ marginLeft: '10px' }}>
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="upidno">
                            Primary UPI ID
                        </label>
                        <div className="flex items-center">
                            <label className="block uppercase tracking-wide font-bold mr-2" style={{ color: 'darkgreen' }}>
                                <input
                                    type="radio"
                                    name="IsPrimaryUPI"
                                    value="true"
                                    checked={formData.IsPrimaryUPI === true} // 
                                    onChange={handleChangecheckbox}
                                />
                                Yes
                            </label>
                            <label className="block uppercase tracking-wide font-bold mr-2" style={{ color: 'darkred' }}>
                                <input
                                    type="radio"
                                    name="IsPrimaryUPI"
                                    value="false"
                                    checked={formData.IsPrimaryUPI === false} // 
                                    onChange={handleChangecheckbox}
                                />
                                No
                            </label>
                        </div>
                    </div>



                </div>
            </form>
        </div>

    );
};

export default BankEdit;